import { Box } from '@chakra-ui/react';

import InfoPromoDetail from 'View/host-stock-promo/component/info-promo-detail';
import ListPromoDetail from 'View/host-stock-promo/component/list-promo-detail';
import { useHostStockPromoState } from 'View/host-stock-promo/state';

import styles from './styles.module.css';

const HostPromoDetail = () => {
  const { state } = useHostStockPromoState();
  return (
    <Box className={styles['host-promo-detail__container']} data-testid="promo-detail">
      <InfoPromoDetail data={state?.selectedDetailPromo} />
      <ListPromoDetail data={state?.selectedDetailPromo} />
    </Box>
  );
};

export default HostPromoDetail;
